module.exports = __webpack_public_path__ + "static/img/23.3895eac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/23.png
// module id = tsxo
// module chunks = 0